import type { MagnetForDisplay } from '../../../../../../../../public-session/src/graphql';
import type { MagnetInBasket } from '../../../shopping-cart-back/actions/standalone';
import { findZalamoMagnetFormatBySize } from '../../../../../../../../../graphql/libs/zalamo-print/src/zalamo-magnet-formats';

export const getMagnetSizeLabel = (sizeId: string): string =>
  findZalamoMagnetFormatBySize(sizeId)?.label ?? sizeId;

export function getMagnetOffers(
  pricing: readonly MagnetForDisplay[],
  basket: readonly MagnetInBasket[],
  photoId: string,
) {
  return pricing
    .filter(
      (offer) =>
        !!findZalamoMagnetFormatBySize(offer?.magnetForDisplayId) &&
        offer.price?.some(
          (price) =>
            !!price?.code && Number.isFinite(price.price) && price.price >= 0,
        ),
    )
    .map((offer) => ({
      sizeId: offer.magnetForDisplayId,
      label: getMagnetSizeLabel(offer.magnetForDisplayId),
      price: offer.price,
      count:
        basket.find(
          (item) =>
            item.photoId === photoId && item.size === offer.magnetForDisplayId,
        )?.count ?? 0,
    }));
}
